<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Zamówienia</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Zamówienia</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Filtry</h5>
            <span class="ibox-toggle" @click="isFiltersOpen = !isFiltersOpen"
              ><i :class="chevronFiltersClass"></i
            ></span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div v-if="filters" class="row">
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-3">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker2"
                      v-model="filterRangeDate"
                      multi-calendars
                      :format="format"
                      range
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Płatność</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.payment_status"
                      mode="tags"
                      placeholder="Płatność"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterPayment"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Faktura papierowa</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.invoice_paper"
                      mode="tags"
                      placeholder="Faktura papierowa"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterInvoice"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Wysyłka</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.delivery_status"
                      mode="tags"
                      placeholder="Wysyłka"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterDelivery"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Status</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.status"
                      mode="tags"
                      placeholder="Status"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterStatus"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Sklep</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.company_localization"
                      mode="tags"
                      placeholder="Sklep"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterLocalization"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Źródło</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.source"
                      mode="single"
                      placeholder="Źródło"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="filterSource"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding" v-if="canDisplaySites">
                <div class="form-group">
                  <label class="control-label">Domena</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.site_pk"
                      mode="single"
                      placeholder="Domena"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="filterSites"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Czy dodano notatkę?</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.has_notes"
                      mode="tags"
                      placeholder="Czy dodano notatkę?"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterInvoice"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding" v-if="canDisplayTags">
                <div class="form-group">
                  <label class="control-label">Tagi</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.tag_pks"
                      mode="tags"
                      placeholder="Tagi"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterTags"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label">Fraza notatki</label>
                  <div class="col-sm-10">
                    <input
                      v-model="filtersNote"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Fraza notatki"
                      required="required"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Zamówienia</h5>
            <span class="ibox-toggle" @click="isOrdersOpen = !isOrdersOpen"
              ><i :class="chevronOrdersClass"></i
            ></span>
          </div>
          <div class="ibox-content" v-show="isOrdersOpen">
            <router-link v-if="canAddOrder" to="/order/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <!-- Podsumowanie nad tabelą -->
            <div class="row" v-if="ordersListSummary && ordersListSummary.data">
              <div class="col-lg-12">
                <div class="ibox float-e-margins">
                  <div class="ibox-title">
                    <h5>Podsumowanie</h5>
                    <span
                      class="ibox-toggle"
                      @click="isSummaryOpen = !isSummaryOpen"
                      ><i :class="chevronSummaryClass"></i
                    ></span>
                  </div>
                  <div class="ibox-content" v-show="isSummaryOpen">
                    <!-- Summary table -->
                    <div class="table-summary">
                      <!-- Column labels row -->
                      <div class="row summary-labels">
                        <div class="col-md-2">
                          <strong>Podsumowanie:</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Liczba zamówień</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma netto</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma netto produkty</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma netto wysyłka</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma brutto</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma VAT</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma adresów</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>Suma paczek</strong>
                        </div>
                      </div>
                      <!-- Values row -->
                      <div class="row summary-values">
                        <div class="col-md-2">
                          <span class="text-muted">Wartości:</span>
                        </div>
                        <div class="col-md-1">
                          <strong>{{ ordersListSummary.data.count }}</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>
                            {{
                              formatCurrency(
                                ordersListSummary.data.final_net_price
                              )
                            }}
                          </strong>
                        </div>
                        <div class="col-md-1">
                          <strong>
                            {{
                              formatCurrency(
                                ordersListSummary.data.products_net_price
                              )
                            }}
                          </strong>
                        </div>
                        <div class="col-md-1">
                          <strong>
                            {{
                              formatCurrency(
                                ordersListSummary.data.delivery_price
                              )
                            }}
                          </strong>
                        </div>
                        <div class="col-md-1">
                          <strong>
                            {{
                              formatCurrency(ordersListSummary.data.gross_price)
                            }}
                          </strong>
                        </div>
                        <div class="col-md-1">
                          <strong>
                            {{
                              formatCurrency(ordersListSummary.data.vat_price)
                            }}
                          </strong>
                        </div>
                        <div class="col-md-1">
                          <strong>{{
                            ordersListSummary.data.address_count
                          }}</strong>
                        </div>
                        <div class="col-md-1">
                          <strong>{{
                            ordersListSummary.data.package_count
                          }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @click="isSearch = false"
                      @change="setRowsPerPage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <div
                  class="order-table-wrapper"
                  @contextmenu.capture="handleTableContextMenu"
                >
                  <EasyDataTable
                    ref="orderTableRef"
                    v-model:server-options="serverOptions"
                    :server-items-length="itemsAll"
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    @click-row="orderDetails"
                    @contextmenu-row="openContextMenu"
                    alternating
                    multi-sort
                    show-index
                    border-cell
                    @update-sort="updateSort"
                    class="messages table-search"
                  >
                    <template #header="header">
                      <span v-if="header.text">{{ header.text }}</span>
                      <input
                        class="table-search"
                        type="text"
                        v-if="header.search"
                        v-model="searchValue[header.value]"
                        @keyup="search"
                        @click="isSearch = true"
                      />
                    </template>
                    <template #item-pk="item">
                      <span v-if="item._isSummary"></span>
                      <span v-else>
                        {{ item.pk }}
                        <NotePopover
                          v-if="item.note_pk"
                          :note-pk="item.note_pk"
                        />
                        <span
                          v-for="(line, index) in getAllegroOrderLines(item)"
                          :key="index"
                          class="dblock"
                        >
                          {{ line }}
                        </span>
                      </span>
                    </template>
                    <template #item-brutto="item">
                      <span v-if="item._isSummary">
                        {{ formatDecimal(pageSummary.gross_price) }}
                      </span>
                      <span v-else>
                        {{
                          formatDecimal(
                            item.info.final_net_price + item.info.vat_price
                          )
                        }}
                      </span>
                    </template>
                    <template #item-actions="item">
                      <button
                        v-if="!item._isSummary"
                        @click.stop="getAdminCard(item.pk)"
                        class="btn btn-primary btn-xs"
                        title="Pobierz kartę"
                      >
                        <i class="fa fa-list-alt"></i>
                      </button>
                    </template>
                  </EasyDataTable>
                </div>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="contextMenu.visible && contextMenu.item && canChangeOrder"
    class="order-context-menu"
    :style="{ top: `${contextMenu.y}px`, left: `${contextMenu.x}px` }"
    @click.stop
  >
    <button
      class="order-context-menu__item"
      :disabled="isDisablePaid(contextMenu.item)"
      @click="runContextAction('/admin_pay_an_order/')"
    >
      Zapłacono
    </button>
    <button
      class="order-context-menu__item"
      :disabled="isDisableCompleted(contextMenu.item)"
      @click="runContextAction('/admin_complete_an_order/')"
    >
      Zakończ zamówienie
    </button>
    <button
      class="order-context-menu__item"
      :disabled="isDisableCanceled(contextMenu.item)"
      @click="runContextAction('/admin_cancel_an_order/')"
    >
      Anuluj zamówienie
    </button>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";
import NotePopover from "../common/NotePopover.vue";
import { getPermittedSiteIds, hasPermission } from "../../permissions";
import { orderPermissionsConst } from "../../constants/orderConstants";
import { tagsPermissionsConst } from "../../constants/tagsConstants";

export default {
  name: "OrderList",
  mixins: [],
  components: {
    Multiselect,
    NotePopover,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddOrder = computed(() =>
      hasPermission(orderPermissionsConst.add)
    );
    // The context menu actions change the order status.
    const canChangeOrder = computed(() =>
      hasPermission(orderPermissionsConst.update)
    );
    // The domain filter only makes sense when the user may view orders on more
    // than one site.
    const permittedSiteIds = getPermittedSiteIds(orderPermissionsConst.view);
    const canDisplaySites = computed(() => permittedSiteIds.length > 1);
    const canDisplayTags = computed(() =>
      hasPermission(tagsPermissionsConst.view)
    );
    const ordersData = computed(() => store.getters.getOrdersData);
    const deleteMessageData = computed(
      () => store.getters.getDeleteMessageData
    );
    const sitesData = computed(() => store.getters.getSitesData);
    const tagsData = computed(() => store.getters.getTagsData);
    const ordersListSummary = computed(
      () => store.getters.getOrdersListSummary
    );
    const actionsOrderData = computed(() => store.getters.getActionsOrderData);
    let headers = [
      { text: "Numer zamówienia", value: "pk", search: true },
      {
        text: "E-mail",
        value: "client_email",
        sortable: true,
        search: true,
      },
      {
        text: "Klient",
        value: "client_name",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
        search: true,
      },
      { text: "Język", value: "lang_display", sortable: true, search: true },
      {
        text: "Waluta",
        value: "currency",
        sortable: true,
        search: true,
      },
      {
        text: "Netto",
        value: "info.final_net_price",
        sortable: true,
        search: true,
      },
      { text: "Brutto", value: "brutto", sortable: true, search: true },
      {
        text: "Netto (bez wysyłki)",
        value: "info.net_price_no_delivery",
        sortable: true,
        search: true,
      },
      {
        text: "Netto wysyłka",
        value: "info.delivery_price_pln",
        sortable: true,
        search: true,
      },
      {
        text: "Stawka VAT",
        value: "info.vat_percent",
        sortable: true,
        search: true,
      },
      {
        text: "Wartość VAT",
        value: "info.vat_price",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba adresów",
        value: "adresses_count",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba paczek",
        value: "info.delivery_packages",
        sortable: true,
        search: true,
      },
      {
        text: "Metoda płatności",
        value: "payment_method_display",
        sortable: true,
        search: true,
      },
      {
        text: "Status zamówienia",
        value: "status_display",
        sortable: true,
        search: true,
      },
      {
        text: "Termin",
        value: "realization_date",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];
    let headersSum = [
      { text: "Numer zamówienia", value: "pk", search: true },
      {
        text: "E-mail",
        value: "client_email",
        sortable: true,
        search: true,
      },
      {
        text: "Klient",
        value: "client_name",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
        search: true,
      },
      { text: "Język", value: "lang_display", sortable: true, search: true },
      {
        text: "Waluta",
        value: "currency",
        sortable: true,
        search: true,
      },
      {
        text: "Netto",
        value: "final_net_price",
        sortable: true,
        search: true,
      },
      { text: "Brutto", value: "brutto", sortable: true, search: true },
      {
        text: "Netto (bez wysyłki)",
        value: "net_price_no_delivery",
        sortable: true,
        search: true,
      },
      {
        text: "Netto wysyłka",
        value: "delivery_price_pln",
        sortable: true,
        search: true,
      },
      {
        text: "Stawka VAT",
        value: "info.vat_percent",
        sortable: true,
        search: true,
      },
      {
        text: "Wartość VAT",
        value: "vat_price",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba adresów",
        value: "adresses_count",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba paczek",
        value: "delivery_packages",
        sortable: true,
        search: true,
      },
      {
        text: "Metoda płatności",
        value: "payment_method_display",
        sortable: true,
        search: true,
      },
      {
        text: "Status zamówienia",
        value: "status_display",
        sortable: true,
        search: true,
      },
      {
        text: "Termin",
        value: "realization_date",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: false },
      { text: "Data modyfikacji", value: "date_modified", sortable: false },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const filters = ref({
      payment_status: [],
      invoice_paper: [],
      delivery_status: [],
      status: ["in_realization", "in_production"],
      company_localization: [],
      source: null,
      site_pk: null,
      has_notes: [],
      tag_pks: [],
      notes_text: "",
    });
    const filterRangeDate = ref();
    const filtersNote = ref([]);
    const summary = ref([]);
    const orderTableRef = ref(null);
    let documentContextMenuHandler = null;
    const contextMenu = ref({
      visible: false,
      x: 0,
      y: 0,
      item: null,
    });
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const isFiltersOpen = ref(true);
    const isOrdersOpen = ref(true);
    const isSummaryOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronOrdersClass = computed(() =>
      isOrdersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronSummaryClass = computed(() =>
      isSummaryOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const pageSummary = ref({
      count: 0,
      final_net_price: 0,
      products_net_price: 0,
      net_price_no_delivery: 0,
      delivery_price_pln: 0,
      vat_price: 0,
      gross_price: 0,
      address_count: 0,
      package_count: 0,
    });

    const filterSites = ref([]);
    const filterTags = ref([]);
    const siteFilterInitialized = ref(false);
    const filterPayment = ref([
      { name: "Opłacone", value: "paid" },
      { name: "Nieopłacone", value: "not_paid" },
    ]);

    const filterInvoice = ref([
      { name: "Tak", value: "True" },
      { name: "Nie", value: "False" },
    ]);

    const filterDelivery = ref([
      { name: "Niewysłana", value: "not_send" },
      { name: "Zatrzymana", value: "stopped" },
      { name: "Wysłana", value: "send" },
      { name: "Doręczona", value: "delivered" },
      { name: "Zwrócona", value: "returned" },
    ]);

    const filterStatus = ref([
      { name: "Nowe", value: "draft" },
      { name: "Negocjowane", value: "negotiated" },
      { name: "Zapisane", value: "saved" },
      { name: "Oczekuje na pliki", value: "waiting_for_files" },
      { name: "Oczekuje na podgląd", value: "waiting_for_preflight" },
      { name: "Oczekuje na płatność", value: "waiting_for_payment" },
      { name: "W realizacji", value: "in_realization" },
      { name: "W produkcji", value: "in_production" },
      { name: "Zrealizowane", value: "done" },
      { name: "Anulowane", value: "canceled" },
      { name: "Usunięte", value: "deleted" },
    ]);
    const filterSource = ref([
      { name: "Wewnętrzne", value: "internal" },
      { name: "Zewnętrzne", value: "external" },
      { name: "Allegro", value: "allegro" },
    ]);

    const filterLocalization = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);

    const getOrders = () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      store.dispatch("getOrders", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
        filters: filters.value,
        notes_text: filtersNote.value,
      });
    };

    const getOrdersSummary = () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }

      const summaryParams = {
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
        filters: filters.value,
        notes_text: filtersNote.value,
      };

      store.dispatch("getOrdersListSummary", summaryParams);
    };

    const deleteMessage = (pk) => {
      showModal.value = false;
      store.dispatch("deleteMessage", {
        pk: pk,
      });
    };
    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editMessage = (item) => {
      cancel();
      store.dispatch("getMessage", { pk: item.pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        localStorage.setItem(
          "ordersSearchValue",
          JSON.stringify(searchValue.value)
        );
        selectPage(1);
        setTimeout(() => {
          getOrders();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      selectPage(1);
      filters.value = {
        payment_status: [],
        invoice_paper: [],
        delivery_status: [],
        status: ["in_realization", "in_production"],
        company_localization: [],
        source: null,
        site_pk: null,
        has_notes: [],
        tag_pks: [],
        notes_text: "",
      };
      getOrders();
      getOrdersSummary();
    };

    const updateSort = () => {
      search.value = true;
    };

    const bodyRowClassNameFunction = (item) => {
      if (item.is_last_message_from_client) {
        return "yellow-row";
      }

      return false;
    };

    const orderDetails = (item) => {
      if (item && item._isSummary) {
        return;
      }
      router.push({
        name: "OrderDetails",
        path: "/order/details/",
        params: { pk: item.pk },
      });
    };

    const closeContextMenu = () => {
      contextMenu.value.visible = false;
      contextMenu.value.item = null;
    };

    const isDisablePaid = (order) => {
      if (!order) return true;
      if (order.payment_method === "deadline") {
        return order.payment_status === "paid" || order.status !== "done";
      }

      if (order.is_external) {
        return (
          (order.status !== "waiting_for_payment" &&
            order.status !== "in_realization" &&
            order.status !== "in_production") ||
          order.payment_method === "after_receiving" ||
          order.payment_status === "paid"
        );
      }

      return (
        order.status !== "waiting_for_payment" ||
        order.payment_method === "after_receiving"
      );
    };

    const isDisableCompleted = (order) => {
      if (!order) return true;
      return (
        order.status !== "in_realization" && order.status !== "in_production"
      );
    };

    const isDisableCanceled = (order) => {
      if (!order) return true;
      return (
        order.status === "canceled" ||
        order.status === "in_production" ||
        order.status === "done" ||
        order.status === "deleted"
      );
    };

    const openContextMenu = (item, event) => {
      if (!item || item._isSummary) {
        closeContextMenu();
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const menuWidth = 220;
      const menuHeight = 130;
      const maxX = Math.max(8, window.innerWidth - menuWidth - 8);
      const maxY = Math.max(8, window.innerHeight - menuHeight - 8);

      contextMenu.value = {
        visible: true,
        x: Math.min(event.clientX, maxX),
        y: Math.min(event.clientY, maxY),
        item,
      };
    };

    const runContextAction = (type) => {
      const selectedOrder = contextMenu.value.item;
      closeContextMenu();
      if (!selectedOrder?.pk || !canChangeOrder.value) return;

      store.dispatch("orderActions", {
        pk: selectedOrder.pk,
        type,
      });
    };

    const handleTableContextMenu = (event) => {
      const tableBody = orderTableRef.value?.$el?.querySelector(
        ".vue3-easy-data-table__body"
      );
      const row = event.target.closest("tr");
      if (!tableBody || !row || !tableBody.contains(row)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const rows = Array.from(tableBody.querySelectorAll("tr"));
      const rowIndex = rows.indexOf(row);
      if (rowIndex < 0) return;
      const item = items.value?.[rowIndex];
      if (!item) return;
      openContextMenu(item, event);
    };

    const handleGlobalContextMenu = (event) => {
      const wrapper = event.target.closest(".order-table-wrapper");
      if (!wrapper) return;

      const tableBody = wrapper.querySelector(".vue3-easy-data-table__body");
      const row = event.target.closest("tr");
      if (!tableBody || !row || !tableBody.contains(row)) return;

      event.preventDefault();
      event.stopPropagation();

      const rows = Array.from(tableBody.querySelectorAll("tr"));
      const rowIndex = rows.indexOf(row);
      if (rowIndex < 0) return;
      const item = items.value?.[rowIndex];
      if (!item) return;
      openContextMenu(item, event);
    };

    const computePageSummary = () => {
      const totals = {
        count: 0,
        final_net_price: 0,
        products_net_price: 0,
        net_price_no_delivery: 0,
        delivery_price_pln: 0,
        vat_price: 0,
        gross_price: 0,
        address_count: 0,
        package_count: 0,
      };

      items.value?.forEach((element) => {
        if (element && !element._isSummary) {
          totals.count += 1;
          const info = element.info || {};
          const finalNet = Number(info.final_net_price) || 0;
          const netNoDelivery = Number(info.net_price_no_delivery) || 0;
          const deliveryPln = Number(info.delivery_price_pln) || 0;
          const vat = Number(info.vat_price) || 0;
          const addresses = Number(element.adresses_count) || 0;
          const packages = Number(info.delivery_packages) || 0;

          totals.final_net_price += finalNet;
          totals.net_price_no_delivery += netNoDelivery;
          totals.delivery_price_pln += deliveryPln;
          totals.vat_price += vat;
          totals.gross_price += finalNet + vat;
          totals.address_count += addresses;
          totals.package_count += packages;
        }
      });

      pageSummary.value = totals;
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return "-";
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    };

    // The order number column joins the Allegro data below the pk, the way the
    // old admin panel does it with its "join" column type.
    const getAllegroOrderLines = (order) =>
      [
        order.allegro_account_name,
        order.allegro_order_id,
        order.allegro_buyer_login,
      ].filter(Boolean);

    const formatDecimal = (value) => {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return "-";
      return numericValue.toLocaleString("pl-PL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const getAdminCard = (pk) => {
      if (pk) {
        store.dispatch("getOrderAdminCard", pk);
      }
    };

    const getMaxPages = () => {
      const total = Number(itemsAll.value) || 0;
      const perPage = Number(serverOptions.value.rowsPerPage) || 1;
      return Math.max(1, Math.ceil(total / perPage));
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    const tableSummary = () => {
      // let tempSummary = {
      //   final_net_price: 0,
      //   net_price_no_delivery: 0,
      //   delivery_price_pln: 0,
      //   vat_price: 0,
      //   delivery_packages: 0,
      //   brutto: 0,
      // };
      // summary.value = [];
      // items.value?.forEach((element) => {
      //   tempSummary.final_net_price += Math.round(element.info.final_net_price);
      //   tempSummary.net_price_no_delivery += Math.round(
      //     element.info.net_price_no_delivery
      //   );
      //   tempSummary.delivery_price_pln += Math.round(
      //     element.info.delivery_price_pln
      //   );
      //   tempSummary.vat_price += Math.round(element.info.vat_price);
      //   tempSummary.brutto += Math.round(
      //     element.info.final_net_price + element.info.vat_price
      //   );
      //   tempSummary.delivery_packages += Math.round(
      //     element.info.delivery_packages
      //   );
      // });
      // summary.value.push(tempSummary);
    };

    store.dispatch("getSites");
    store.dispatch("getTags");

    onMounted(() => {
      if (localStorage.getItem("filters") !== "null") {
        let tempFilters = localStorage.getItem("filters");
        filters.value = {
          payment_status: [],
          invoice_paper: [],
          delivery_status: [],
          status: ["in_realization", "in_production"],
          company_localization: [],
          source: null,
          site_pk: null,
          has_notes: [],
          tag_pks: [],
          notes_text: "",
          ...(JSON.parse(tempFilters) || {}),
        };
        if (Array.isArray(filters.value.site_pk)) {
          filters.value.site_pk = filters.value.site_pk[0] || null;
        }
        delete filters.value.is_external;
      }

      if (
        localStorage.getItem("ordersRangeDate") !== null &&
        localStorage.getItem("ordersRangeDate") !== undefined &&
        localStorage.getItem("ordersRangeDate") !== "undefined"
      ) {
        filterRangeDate.value = localStorage.getItem("ordersRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }

      if (localStorage.getItem("filtersNote") !== "null") {
        let filtersNoteTemp = localStorage.getItem("filtersNote");
        filtersNote.value = JSON.parse(filtersNoteTemp);
      }
      if (localStorage.getItem("ordersSearchValue") !== null) {
        searchValue.value = localStorage.getItem("ordersSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      documentContextMenuHandler = (event) => handleGlobalContextMenu(event);
      document.addEventListener(
        "contextmenu",
        documentContextMenuHandler,
        true
      );
      document.addEventListener("click", closeContextMenu);
      document.addEventListener("scroll", closeContextMenu, true);
      window.addEventListener("resize", closeContextMenu);
    });

    onUnmounted(() => {
      if (documentContextMenuHandler) {
        document.removeEventListener(
          "contextmenu",
          documentContextMenuHandler,
          true
        );
      }
      document.removeEventListener("click", closeContextMenu);
      document.removeEventListener("scroll", closeContextMenu, true);
      window.removeEventListener("resize", closeContextMenu);
    });

    watch(
      () => [filters.value, filtersNote.value, searchValue.value],
      function () {
        localStorage.setItem("filters", JSON.stringify(filters.value));
        localStorage.setItem("filtersNote", JSON.stringify(filtersNote.value));
        localStorage.setItem(
          "ordersSearchValue",
          JSON.stringify(searchValue.value)
        );
        getOrders();
        getOrdersSummary();
      },
      { deep: true }
    );

    watch(
      () => filterRangeDate.value,
      function () {
        localStorage.setItem(
          "ordersRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getOrders();
        getOrdersSummary();
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        if (newValue.data) {
          const rawSites = Array.isArray(newValue.data?.results)
            ? newValue.data.results
            : [];
          filterSites.value = rawSites
            .filter((element) => permittedSiteIds.includes(element.pk))
            .map((element) => ({
              name: element.name,
              value: element.pk,
            }));

          if (!hasSiteOptionValue(filterSites.value, filters.value.site_pk)) {
            const defaultSiteValue = getSiteValueFromCurrentUrl(
              filterSites.value
            );
            if (defaultSiteValue !== null) {
              filters.value.site_pk = defaultSiteValue;
            }
          }

          if (!siteFilterInitialized.value) {
            siteFilterInitialized.value = true;
            getOrders();
            getOrdersSummary();
          }
        }
      }
    );

    watch(
      () => tagsData.value,
      function (newValue) {
        if (newValue.data && newValue.data.length > 0) {
          newValue.data?.forEach((element) => {
            filterTags.value.push({
              name: element.name,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => ordersData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        computePageSummary();
        // Append summary row as the last row in the table
        const summaryRow = {
          _isSummary: true,
          pk: "Suma strony",
          client_email: "",
          client_name: "",
          company_localization_display: "",
          lang_display: "",
          currency: "",
          info: {
            final_net_price: Math.round(pageSummary.value.final_net_price),
            net_price_no_delivery: Math.round(
              pageSummary.value.net_price_no_delivery
            ),
            delivery_price_pln: Math.round(
              pageSummary.value.delivery_price_pln
            ),
            vat_percent: "",
            vat_price: Math.round(pageSummary.value.vat_price),
            delivery_packages: Math.round(pageSummary.value.package_count),
          },
          brutto: Number(pageSummary.value.gross_price.toFixed(2)),
          adresses_count: Math.round(pageSummary.value.address_count),
          payment_method_display: "",
          status_display: "",
          realization_date: "",
          date_added: "",
          date_modified: "",
        };
        items.value.push(summaryRow);
        loading.value = false;
        tableSummary();
      }
    );

    watch(
      () => deleteMessageData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Grupa rabatów została usunięta",
          });
        }
        getOrders();
      }
    );

    watch(
      () => actionsOrderData.value,
      function (newValue) {
        if (!newValue?.status) return;

        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Zamówienie zostało zaktualizowane!",
          });
          getOrders();
          getOrdersSummary();
        } else {
          let msg = [];
          for (const [key, value] of Object.entries(newValue.data || {})) {
            msg.push(key + ": " + value);
          }
          store.dispatch("showToaster", {
            type: "error",
            content: msg[0] || "Nie udało się zaktualizować zamówienia",
          });
        }
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getOrders();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      headersSum,
      items,
      itemsAll,
      loading,
      canAddOrder,
      canChangeOrder,
      canDisplaySites,
      canDisplayTags,
      serverOptions,
      showModal,
      deleteMessage,
      deleteName,
      cancel,
      editMessage,
      searchValue,
      isSearch,
      search,
      rowsPerPage,
      resetFilters,
      updateSort,
      bodyRowClassNameFunction,
      orderDetails,
      contextMenu,
      openContextMenu,
      handleTableContextMenu,
      runContextAction,
      isDisablePaid,
      isDisableCompleted,
      isDisableCanceled,
      filters,
      filterRangeDate,
      filtersNote,
      format,
      filterPayment,
      filterInvoice,
      filterDelivery,
      filterStatus,
      filterSource,
      filterLocalization,
      filterSites,
      filterTags,
      getAdminCard,
      selectPage,
      clampPage,
      getMaxPages,
      setRowsPerPage,
      summary,
      formatCurrency,
      formatDecimal,
      getAllegroOrderLines,
      ordersListSummary,
      pageSummary,
      orderTableRef,
      isFiltersOpen,
      isOrdersOpen,
      isSummaryOpen,
      chevronFiltersClass,
      chevronOrdersClass,
      chevronSummaryClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
.table-summary {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.summary-labels,
.summary-values {
  margin: 0;
  font-size: 14px;
}

.summary-labels .col-md-1,
.summary-labels .col-md-2,
.summary-values .col-md-1,
.summary-values .col-md-2 {
  padding: 8px;
  text-align: center;
  border-right: 1px solid #dee2e6;
}

.summary-labels .col-md-1:last-child,
.summary-labels .col-md-2:last-child,
.summary-values .col-md-1:last-child,
.summary-values .col-md-2:last-child {
  border-right: none;
}

.summary-labels strong {
  color: #495057;
  font-size: 12px;
}

.summary-values strong {
  color: #495057;
}

.summary-values .text-muted {
  color: #6c757d;
  font-size: 12px;
}

.summary-labels {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

.order-context-menu {
  position: fixed;
  z-index: 3000;
  min-width: 220px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  padding: 6px 0;
}

.order-context-menu__item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  text-align: left;
  border: 0;
  background: transparent;
  color: #333;
}

.order-context-menu__item:hover:not(:disabled) {
  background: #f5f5f5;
}

.order-context-menu__item:disabled {
  color: #a7a7a7;
  cursor: not-allowed;
}
</style>
